import React, { useEffect } from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { DialogActions } from '@e3dc-react/shell/Elements/Dialog/Dialog'
import NotificationModalContent from './NotificationModalContent'
import useNotificationContext from '../../hooks/use-notification-context'
import { sendMessageToReactNative } from '@e3dc-react/shell/Libs/react-native'

export interface NotificationModalProps {
  onClose: () => void
  place: number
}

/**
 * Displays mandatory notifications with pagination to the user.
 */
const NotificationModal: React.FC<NotificationModalProps> = ({ onClose, place }) => {
  const { t } = useCustomTranslation()
  const { mandatoryNotifications, markNotificationAsRead } = useNotificationContext()

  const closeAction: DialogActions = {
    secondary: [
      {
        name: t('common.close'),
        onClick: () => onClose(),
      },
    ],
  }

  useEffect(() => {
    sendMessageToReactNative({ open: true, type: 'overlay' })
    return () => {
      sendMessageToReactNative({ open: false, type: 'overlay' })
    }
  }, [])

  const onMarkNotificationsAsRead = (id: number): void => {
    markNotificationAsRead(id).then(() => {
      const isLastNotification = mandatoryNotifications.length === 1
      if (isLastNotification) onClose()
    })
  }

  return (
    <Dialog title={t('notification.dialog.title')} place={place} onClose={onClose} actions={closeAction} maxWidth="md" scrollable={false}>
      {mandatoryNotifications.length > 0 && (
        <NotificationModalContent notifications={mandatoryNotifications} onMarkNotificationsAsRead={onMarkNotificationsAsRead} />
      )}
    </Dialog>
  )
}

export default NotificationModal
